import controller from './vd-product-badge.controller'
import template from './vd-product-badge.html'

export default {
  bindings: {
    current: '<?',
    exactMatch: '<?',
    hideDescription: '<?',
    highlight: '<?',
    hyperlink: '@?',
    ignoreCurrency: '<?',
    interactive: '@?',
    price: '<?',
    product: '<',
    size: '@?',
    variantCount: '<?',
  },
  controller,
  template,
}
